var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"googleMap",class:{'google-map-message': _vm.card},style:(_vm.mapStyle)}),(_vm.map)?[_vm._t("default",null,{"map":_vm.map})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }